import type { ErrorRegistryShape } from '../common/common.error';

/** 파일 공통(포트폴리오 파일 · 관리 이력 첨부 · 이미지) */
export const FILE_ERROR = {
  /** 레코드는 있지만 저장소에 파일이 없음 · 없는 이미지 */
  NOT_FOUND_FILE: { status: 404, message: 'File not found' },
  /** 허용하지 않는 형식 · 내용과 다른 형식 · 빈 파일. data: { reason } */
  BAD_REQUEST_FILE_TYPE: { status: 400, message: 'File type not allowed' },
} as const satisfies ErrorRegistryShape;
